/**
 * Fabio Jr.
 * Classe para reordenar as questões do survey.
 */

Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Reorder = {

    createDivToReorderQuestion: function (sectionID, parentQuestionId) {

        var popupElement        = document.querySelector('#Survey'),
            questionFormOverlay = document.createElement('div'),
            questionFormContent = document.createElement('div');

        questionFormOverlay.id = 'SurveyLinkOverlay';
        questionFormContent.id = 'SurveyReorderForm';
        questionFormContent.appendChild(Greenmile.Survey.Templates.SurveyReorderQuestionTemplate());

        popupElement.appendChild(questionFormOverlay);
        popupElement.appendChild(questionFormContent);

        this.getQuestions(sectionID, parentQuestionId);
        this.appendQuestionToReorder();
        this.addButtonGroupListeners();

    },

    addButtonGroupListeners: function () {
        var cancelButton = document.querySelector('#ReorderCancelButton'),
            saveButton   = document.querySelector('#ReorderSaveButton');

        saveButton.addEventListener('click', (function (scope) {
            return function () {
                scope.saveOrderQuestions();
                scope.dismissQuestionForm();
            };
        }(this)));

        cancelButton.addEventListener('click', (function (scope) {
            return function () {
                scope.dismissQuestionForm();
            };
        }(this)));
    },

    dismissQuestionForm: function () {
        var formOverlay   = document.querySelector('#SurveyLinkOverlay'),
            formContent   = document.querySelector('#SurveyReorderForm'),
            overlayParent = formOverlay.parentNode,
            formParent    = formContent.parentNode;

        overlayParent.removeChild(formOverlay);
        formParent.removeChild(formContent);
    },

    getQuestions: function (sectionID, parentQuestionId) {

        var section = Greenmile.Survey.Data.findSection(sectionID);
        this.questionsReorder = Greenmile.Survey.Data.getQuestionsBySection(section, parentQuestionId);

    },

    appendQuestionToReorder: function () {

        var questions = document.getElementById('questionsToReorder'),
            question;


        for (var i = 0, sizeQuestions = this.questionsReorder.questions.length; i < sizeQuestions; i++) {

            question = this.questionsReorder.questions[i];
            var divQuestion = document.createElement('div');
            var labelQuestion = document.createElement("label");

            divQuestion.setAttribute('class', "question");
            divQuestion.setAttribute('id', question.id);

            labelQuestion.insertAdjacentHTML('beforeend', this.questionsReorder.questions[i].question);
            labelQuestion.setAttribute('class', "labelQuestion");

            divQuestion.appendChild(labelQuestion);

            questions.appendChild(divQuestion);


        }

        $("#questionsToReorder").sortable({ axis: "y" });
    },

    saveOrderQuestions: function () {

        var questionsInOrderly = document.getElementById('questionsToReorder'),
            section            = Greenmile.Survey.Data.findSection(this.questionsReorder.sectionID),
            order              = 0,
            i, size,
            question,
            sectionQuestions   = section.surveyQuestions,
            filterQuestions    = function (question) {
                return question.id.toString() === questionsInOrderly.children[i].id;
            };

        for (i = 0, size = questionsInOrderly.children.length; i < size; i++) {

            question = sectionQuestions.filter(filterQuestions);

            question[0].order = order++;
        }

        Greenmile.Survey.Form.reconstructSection(section);

    }

};
